const DISABLED_CLASS_NAME = 'dn-link--disabled';

const defaultOptions = () => {
  return {
    defaultHref  : null,
    defaultTarget: null,
    enabledClass : null,
    disabledClass: null,
    disabled     : false,
  }
}

const functions = {
  enabled: {
    a($el, options, useDefault) {
      const href   = useDefault ? options.defaultHref   : options.href,
            target = useDefault ? options.defaultTarget : options.target;

      $el.data('href-origin', null);
      $el.data('target-origin', null);
      $el.removeAttr('nohref');
      $el.attr('href', href);
      if (target) $el.attr('target', target);
      $el.removeClass(DISABLED_CLASS_NAME);

      if (options.enabledClass)  $el.addClass(options.enabledClass);
      if (options.disabledClass) $el.removeClass(options.disabledClass);
    },
  },

  disabled: {
    a($el, options) {
      $el.data('href-origin', options.href);
      $el.data('target-origin', options.target);

      $el.removeAttr('href');
      $el.attr('nohref', 'nohref');
      $el.addClass(DISABLED_CLASS_NAME);

      if (options.enabledClass)  $el.removeClass(options.enabledClass);
      if (options.disabledClass) $el.addClass(options.disabledClass);
    },
  },
};

export default {
  bind(el, binding, v) {
    if (!binding.value) return;
    const $el            = $(el),
          href           = $el.prop('href'),
          target         = $el.prop('target'),
          options        = Object.assign(defaultOptions(), {href: href, target: target}, typeof binding.value === 'string' ? {id: binding.value} : binding.value),
          id             = options.id,
          tagName        = el.tagName.toLowerCase();

    let currentEnabled = false;

    // オリジナルの情報をエレメントに保持しておく
    el.setAttribute('data-dn-linkset-origin-id', id);
    el.setAttribute('data-dn-linkset-origin-href', href);

    // まず無効化しておく
    functions.disabled[tagName]($el, options);

    const tick = () => {
      const hasDefault = options.defaultHref;

      const isEnabled = !options.disabled && (hasDefault || v.context.$store.getters['links/enabled'](id));
      if (isEnabled === currentEnabled) return;
      if (isEnabled && !currentEnabled) {
        functions.enabled[tagName]($el, options, hasDefault);
      } else if (!isEnabled && currentEnabled) {
        functions.disabled[tagName]($el, options);
      }
      currentEnabled = isEnabled;
    }

    tick();
    el._dn_linkset_unwatcher = v.context.$watch('$store.state.links.links', tick, {deep: true});
  },

  unbind(el) {
    if (el._dn_linkset_unwatcher) {
      el._dn_linkset_unwatcher();
      el._dn_linkset_unwatcher = null;
      delete el._dn_linkset_unwatcher;
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/ui/directives/linkset.js